<!-- used in VehiclePageV2.vue -->
<!-- https://dev.azure.com/mydigitalsystems/53bca99b-180e-49c3-b7f5-b8aad6ad1893/_apis/wit/attachments/d6f057b9-551e-45ef-96a8-2260aa95b785?fileName=Tyre%20Configuration%20Index.eml -->
<!-- explanation for tyre indexes -->

<template>
  <div class="main-container">
    <div class="tyre-grid-legend">
      <div class="tyre-grid-legend-item">
        <div class="tyre-grid-legend-color changes"></div>
        <div class="tyre-grid-legend-desc">Changes</div>
      </div>
      <div class="tyre-grid-legend-item">
        <div class="tyre-grid-legend-color saved"></div>
        <div class="tyre-grid-legend-desc">Occupied</div>
      </div>
    </div>
    <div class="front-tyre-container">
      <div v-if="tyreLayout">
        <!-- tyreLayout passed -->
        <div class="tyre-container">
          <div
            v-if="shouldRender('0C', 'FrontRear')"
            :class="[
              'front-tyre tyre',
              {
                'tyre-selected': tyreIsSelected('0C', 'FrontRear'),
                'tyre-unsaved-changes': tyreHasUnsavedChanges('0C', 'FrontRear'),
                'tyre-saved': tyreIsSaved('0C', 'FrontRear'),
                'tyre-disabled': tyreIsDisabled('0C'),
              },
            ]"
            @click="tyreClicked('0C', 'FrontRear')"
            v-html="getTyreDescription('0C')"
          >
          </div>
        </div>
      </div>
    </div>
    <div class="outline-container">
      <div class="tyre-outline-container">
        <div v-if="tyreLayout">
          <!-- tyreLayout passed -->
          <div
            v-for="row in Array.from({ length: 10 }, (_, index) => {
              return index;
            })"
            :key="row"
            class="tyre-row"
          >
            <!-- iterate from 0 to 9 -->
            <div
              v-for="col in Array.from({ length: 5 }, (_, index) => {
                return index;
              })"
              :key="col"
              class="tyre-container"
            >
              <!-- iterate from 0 to 4 -->
              <div
                v-if="shouldRender(col * 10 + row, 'LeftRight')"
                :class="[
                  'tyre',
                  {
                    'tyre-selected': tyreIsSelected(col * 10 + row, 'LeftRight'),
                    'tyre-unsaved-changes': tyreHasUnsavedChanges(col * 10 + row, 'LeftRight'),
                    'tyre-saved': tyreIsSaved(col * 10 + row, 'LeftRight'),
                    'tyre-disabled': tyreIsDisabled(col * 10 + row),
                  },
                ]"
                @click="tyreClicked(col * 10 + row, 'LeftRight')"
                v-html="getTyreDescription(col * 10 + row)"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vehicle-outline">
        <strong>FRONT</strong>
        <div class="steering-wheel">
          <img
            src="https://dsmlib.logistics.systems/Icons/LightSteeringWheel.png"
            alt="Steering Wheel"
            draggable="false"
          />
        </div>
        <div class="seats">
          <img src="https://dsmlib.logistics.systems/Icons/PersonSeatBelt.png" alt="Passenger Seat" draggable="false" />
          <img src="https://dsmlib.logistics.systems/Icons/PersonSeatBelt.png" alt="Driver Seat" draggable="false" />
        </div>
        <div class="spare-tyres tyre-container">
          <div
            v-for="n in Array.from({ length: 4 }, (_, index) => {
              return index + 100;
            })"
            :key="n"
          >
            <!-- iterate from 100 to 103 -->
            <div
              v-if="showSpares || shouldRender(n, 'LeftRight')"
              :class="[
                'tyre',
                {
                  'tyre-selected': tyreIsSelected(n, 'LeftRight'),
                  'tyre-unsaved-changes': tyreHasUnsavedChanges(n, 'LeftRight'),
                  'tyre-saved': tyreIsSaved(n, 'LeftRight'),
                  'tyre-disabled': tyreIsDisabled(n),
                },
              ]"
              @click="tyreClicked(n, 'LeftRight')"
            >
              <!-- iterate from 0 to 3 -->
              <span>SPARE{{ n - 99 }}</span>
            </div>
          </div>
        </div>
        <strong>REAR</strong>
      </div>
      <div class="tyre-outline-container">
        <div v-if="tyreLayout">
          <!-- tyreLayout passed -->
          <div
            v-for="row in Array.from({ length: 10 }, (_, index) => {
              return index;
            })"
            :key="row"
            class="tyre-row"
          >
            <!-- iterate from 0 to 9 -->
            <div
              v-for="col in Array.from({ length: 5 }, (_, index) => {
                return index + 5;
              })"
              :key="col"
              class="tyre-container"
            >
              <!-- iterate from 5 to 9 -->
              <div
                v-if="shouldRender(col * 10 + row, 'LeftRight')"
                :class="[
                  'tyre',
                  {
                    'tyre-selected': tyreIsSelected(col * 10 + row, 'LeftRight'),
                    'tyre-unsaved-changes': tyreHasUnsavedChanges(col * 10 + row, 'LeftRight'),
                    'tyre-saved': tyreIsSaved(col * 10 + row, 'LeftRight'),
                    'tyre-disabled': tyreIsDisabled(col * 10 + row),
                  },
                ]"
                @click="tyreClicked(col * 10 + row, 'LeftRight')"
                v-html="getTyreDescription(col * 10 + row)"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rear-tyre-container">
      <div v-if="tyreLayout">
        <!-- tyreLayout passed -->
        <div class="tyre-container">
          <div
            v-if="shouldRender('1C', 'FrontRear')"
            :class="[
              'rear-tyre tyre',
              {
                'tyre-selected': tyreIsSelected('1C', 'FrontRear'),
                'tyre-unsaved-changes': tyreHasUnsavedChanges('1C', 'FrontRear'),
                'tyre-saved': tyreIsSaved('1C', 'FrontRear'),
                'tyre-disabled': tyreIsDisabled('1C'),
              },
            ]"
            @click="tyreClicked('1C', 'FrontRear')"
            v-html="getTyreDescription('1C')"
          >
          </div
        ></div>
      </div>
    </div>
    <div v-if="displayShowAllCheckbox" class="show-all-checkbox-container">
      <CheckBox title="Show All" :isChecked.sync="showAll_" @checkBoxClicked="showAllCheckboxClicked" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      tyreLayout_: {}, // by convention, private variables should begin with an underscore
      selectedTyre_: '', // but vue doesn't support that: https://v2.vuejs.org/v2/api/#data
      showAll_: false,
    };
  },
  props: {
    tyreLayout: {
      type: Array,
      default: function () {
        return [];
      },
    }, // used to specify which positions to render
    // FORMAT: [
    //   {
    //      "index": 1,
    //      "layoutType": "LeftRight" | "FrontRear", (OPTIONAL) (used to override layoutType prop. if not provided, will use value passed in layoutType prop)
    //      "state": "normal" | "changes" | "saved", (OPTIONAL) (if field doesn't exist OR is left blank OR contains any other value, it will default to "normal")
    //      "description": custom_description_string, (OPTIONAL) (if passed, will return this @select, if not, a generic description will be returned)
    //      "disabled": true | false, (OPTIONAL) (if true, will disable clicking on this position.)
    //   },
    //   {
    //      "index": 2,
    //   },
    // ]

    // IMPORTANT!!!
    // when updating tyreLayout from the parent, create a new array and assign it, instead of just modifying the desired field
    // the UI won't re-render if you don't create a new array
    // example:
    // this.tyreLayout = [...this.tyreLayout]
    // this.tyreLayout[0]["state"] = "saved"

    layoutType: { type: String, default: 'LeftRight' }, // "LeftRight" | "FrontRear"
    // used when there is no override field in tyreLayout and selectedTyre

    selectedTyre: {
      type: Object,
      default: function () {
        return {};
      },
    },
    // used to select a position programatically, value will be updated if user selects from grid (use .sync)
    // FORMAT: {
    //   "index": selected_tyre_index,
    //   "layoutType": "LeftRight" | "FrontRear", (OPTIONAL) (will use value passed in layoutType prop if not provided)
    // }

    selectedTyreDetails: {
      type: Object,
      default: function () {
        return {};
      },
    },
    // used to get details of the current selected tyre, returns the same thing as in @select (use .sync)
    // updated when user clicks on a tyre OR when selectedTyre is updated programatically
    // DO NOT USE THIS PROP TO SELECT A TYRE, the component will NOT react to changes in this prop, use selectedTyre instead
    // FORMAT: {
    //   "index": integer_index,
    //   "layoutType": "LeftRight" | "FrontRear",
    //   "description": string_describing_tyre_position, (if a custom description is passed in tyreLayout, that will be returned, if not, a generic description will be generated)
    //   "colNo": col_integer | "", (for spare tyres, an empty string will be returned instead)
    //   "rowNo": row_integer | "", (for spare tyres, an empty string will be returned instead)
    //   "state": "normal" | "changes" | "saved",
    // }

    showAll: { type: Boolean, default: false },
    // show/hide all tyre positions EXCEPT spare tyres. value will be updated if user toggles show all checkbox (use .sync)

    showSpares: { type: Boolean, default: true }, // show/hide spare tyres
    displayShowAllCheckbox: { type: Boolean, default: false }, // show/hide Show All Checkbox

    // EVENTS:
    // @tyreClicked - fired when user clicks on a tyre from the grid, does NOT fire when selectedTyre is updated programatically
    // returns: {
    //   "index": integer_index,
    //   "layoutType": "LeftRight" | "FrontRear",
    //   "description": string_describing_tyre_position, (if a custom description is passed in tyreLayout, that will be returned, if not, a generic description will be generated)
    //   "colNo": col_integer | "", (for spare tyres, an empty string will be returned instead)
    //   "rowNo": row_integer | "", (for spare tyres, an empty string will be returned instead)
    //   "state": "normal" | "changes" | "saved",
    // }
    // the exact same body will also be updated to the selectedTyreDetails prop, if .sync is used
  },
  methods: {
    remapTyreLayout: function () {
      // used to convert tyreLayout format into tyreLayout_ format
      if (!this.tyreLayout || !Array.isArray(this.tyreLayout)) {
        // if tyreLayout is null or is not an array
        this.tyreLayout_ = {};
        return;
      }

      const remappedTyreLayout = {};
      for (let tyre of this.tyreLayout) {
        if (tyre['index'] == null) {
          // index integer 0 is a falsy value, need to explicitly check for nullish values
          continue; // proceed to next iteration if this object has no index value
        }

        const options = {};

        for (let key in tyre) {
          if (key != 'index') {
            options[key] = tyre[key];
          }
        }

        if (
          options['layoutType'] == 'FrontRear' || // if override layoutType is "FrontRear"
          (this.layoutType == 'FrontRear' && !options['layoutType']) // if base layoutType is "FrontRear" and there is no override
        ) {
          remappedTyreLayout[`${tyre['index']}C`] = Object.keys(options).length > 0 ? options : null; // append C to the end of the index
        } else {
          remappedTyreLayout[tyre['index']] = Object.keys(options).length > 0 ? options : null; // use index as key
        }
      }

      this.tyreLayout_ = remappedTyreLayout;
    },
    convertSelectedTyreIndex: function () {
      // converts { "index": 1, "layoutType": "FrontRear" } from selectedTyre prop
      // into "1C" for selectedTyre_ data field
      // basically add a C to the end of index if it is a FrontRear tyre

      if (!this.selectedTyre || this.selectedTyre['index'] == null) {
        // selectedTyre prop is null or does not contain index
        this.selectedTyre_ = ''; // index integer 0 is a falsy value, need to explicitly check for nullish values
        return;
      }

      if (
        this.selectedTyre['layoutType'] == 'FrontRear' || // if override layoutType is "FrontRear"
        (this.layoutType == 'FrontRear' && !this.selectedTyre['layoutType']) // if base layoutType is "FrontRear" and there is no override
      ) {
        this.selectedTyre_ = `${this.selectedTyre['index']}C`; // append C to the end of the index
      } else {
        this.selectedTyre_ = this.selectedTyre['index'];
      }
    },
    shouldRender: function (index, layoutType) {
      if (this.showAll_) return true;
      return this.tyreLayout_ ? this.tyreLayout_.hasOwnProperty(index) : false;
      // even if the value of that field is null or undefined, that tyre should still render
      // this is to prevent having to create an empty object for every tyre needed to be rendered without any additional specifications
    },
    tyreIsSelected: function (index, layoutType) {
      return this.selectedTyre_.toString() === index.toString();
      // need to cast and use strict equality, because an empty string and 0 are both falsy values, and will return true when compared loosely
    },
    tyreHasUnsavedChanges: function (index, layoutType) {
      if (!this.tyreLayout_) {
        // tyreLayout is null
        return false;
      }

      return this.tyreLayout_[index] ? this.tyreLayout_[index]['state'] == 'changes' : false;
    },
    tyreIsSaved: function (index, layoutType) {
      if (!this.tyreLayout_) {
        // tyreLayout is null
        return false;
      }

      return this.tyreLayout_[index] ? this.tyreLayout_[index]['state'] == 'saved' : false;
    },
    tyreIsDisabled: function (index) {
      const { disabled } = this.tyreLayout.find((tyre) => tyre.index == index) || {};
      return disabled ?? false;
    },
    tyreClicked: function (index, layoutType) {
      const { disabled } = this.tyreLayout.find((tyre) => tyre.index == index) || {};
      if (disabled) return;

      if (this.selectedTyre_.toString() === index.toString()) {
        // if user clicks on an already selected tyre, need strict equality because integer 0 is falsy
        this.selectedTyre_ = ''; // unselect tyre
        this.$emit('update:selectedTyre', {});
        this.$emit('update:selectedTyreDetails', {});
        this.$emit('tyreClicked', null);
        return;
      }

      this.selectedTyre_ = index;

      this.$emit('update:selectedTyre', {
        index: layoutType == 'FrontRear' ? index.substring(0, index.length - 1) : index,
        layoutType: layoutType,
      });

      const selectedTyreDetails = this.generateTyreDetails(index, layoutType);
      this.$emit('tyreClicked', selectedTyreDetails);
      this.$emit('update:selectedTyreDetails', selectedTyreDetails);
    },
    generateTyreDetails: function (index, layoutType) {
      // pass in converted index (0C and 1C for front and rear), and layoutType ("FrontRear" or "LeftRight")
      const selectedTyreDetails = {
        index: layoutType == 'FrontRear' ? index.substring(0, index.length - 1) : index,
        layoutType: layoutType,
        state:
          this.tyreLayout_ && this.tyreLayout_[index] && this.tyreLayout_[index]['state'] ?
            this.tyreLayout_[index]['state']
          : 'normal',
      };
      switch (layoutType) {
        case 'LeftRight':
          if (index >= 100) {
            selectedTyreDetails['colNo'] = ''; // spare tyres do not have any col and row value
            selectedTyreDetails['rowNo'] = '';
            selectedTyreDetails['description'] = 'Spare Tyre';
          } else {
            selectedTyreDetails['colNo'] = parseInt(index / 10 + 1);
            selectedTyreDetails['rowNo'] = parseInt((index % 10) + 1);
            if (index <= 49) {
              selectedTyreDetails['description'] = 'Left Side ';
            } else {
              selectedTyreDetails['description'] = 'Right Side ';
            }
            selectedTyreDetails['description'] +=
              `Column ${selectedTyreDetails['colNo']} Row ${selectedTyreDetails['rowNo']} Tyre`;
          }
          break;

        case 'FrontRear':
          selectedTyreDetails['colNo'] = 1;
          selectedTyreDetails['rowNo'] = 1;
          if (index == '0C') {
            selectedTyreDetails['description'] = 'Front Tyre';
          } else {
            selectedTyreDetails['description'] = 'Rear Tyre';
          }
          break;
      }
      if (this.tyreLayout_ && this.tyreLayout_[index] && this.tyreLayout_[index]['description']) {
        // if custom description passed
        selectedTyreDetails['description'] = this.tyreLayout_[index]['description']; // overwrite generic description
      }

      return selectedTyreDetails;
    },
    showAllCheckboxClicked: function () {
      this.$emit('update:showAll', this.showAll_);
    },
    getTyreDescription(index) {
      const { description } = this.tyreLayout.find((item) => item.index == index) ?? {};
      return `<span ${!description ? `style="color: #838383"` : ''}>${description || index}</span>`;
    },
  },
  mounted() {
    this.remapTyreLayout();
    this.convertSelectedTyreIndex();
    this.showAll_ = this.showAll;
  },
  watch: {
    tyreLayout: {
      handler: function (newTyreLayout) {
        this.remapTyreLayout();
      },
      deep: true,
    },
    selectedTyre: {
      handler: function (newSelectedTyre) {
        this.convertSelectedTyreIndex();

        if (!this.selectedTyre_) {
          // if no tyre was selected
          return; // exit watcher
        }

        // generate tyre details object and emit
        this.$emit(
          'update:selectedTyreDetails',
          this.generateTyreDetails(this.selectedTyre_, newSelectedTyre['layoutType'] || this.layoutType),
        );
      },
      deep: true,
    },
    showAll: function () {
      this.showAll_ = this.showAll;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main-container {
  height: 100%;
  width: 100%;
  padding: 0 5px 0 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;

  --tyre-grid-changes-color: rgb(255, 153, 51);
  --tyre-grid-saved-color: rgb(121, 210, 121);

  > .outline-container {
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 4px 0;

    > .tyre-outline-container {
      height: fit-content;
      width: fit-content;
      display: flex;
      flex-direction: column;

      .tyre-row {
        margin: 6px 0;
        display: flex;
        flex-direction: row;
        gap: 8px;
      }
    }

    > .vehicle-outline {
      height: 375px;
      width: 180px;
      min-width: 180px;
      margin: 0px 8px;
      border: 1px solid black;
      display: flex;
      flex-direction: column;
      text-align: center;

      > .steering-wheel {
        display: flex;
        justify-content: flex-end;
        margin-right: 15px;

        > img {
          height: 60px;
          width: 60px;
        }
      }

      > .seats {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: -12px;
        padding: 0 15px 0 15px;

        > img {
          height: 60px;
          width: 60px;
        }
      }

      > .spare-tyres {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > div {
          height: 24px;
          width: 60px;
          margin: 5px 0 5px 0px;
        }
      }
    }
  }

  .tyre-container {
    width: 24px;
    height: 32px;
    .tyre {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: 1px solid black;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.7rem;
      user-select: none;

      &.tyre-unsaved-changes {
        background-color: var(--tyre-grid-changes-color) !important;
      }

      &.tyre-saved {
        background-color: var(--tyre-grid-saved-color) !important;
      }

      &.tyre-disabled {
        cursor: not-allowed;
      }

      &.tyre-selected {
        background-color: rgb(255, 255, 153);
        border: none !important;
        outline: 3px dotted black;
        outline-offset: -1px;
      }
    }
  }

  .tyre-grid-legend{
    position: absolute;
    right: 3%;
    top: 1%;
    // padding:0px 4px;
    display: flex;
      flex-direction: column;
      gap: 4px;
    .tyre-grid-legend-item{
      display: flex;
      gap: 8px;
      align-items: center;
      .tyre-grid-legend-color{
        width: 16px;
        height: 16px;
        outline: 1px solid black;
        border-radius: 2px;

        &.changes{
          background-color: var(--tyre-grid-changes-color);
        }

        &.saved{
          background-color: var(--tyre-grid-saved-color);
        }
      }
    }
  }
}
</style>
